/* This file was generated by running "node scripts/generateTranslations.js". */
/* Created: 2026-09-23 20:23:54 */

const Keys = {
  paxSelection: 'paxSelection',
  paxSelectionStaticTitle: 'paxSelectionStaticTitle',
  numberOfGuests: 'numberOfGuests',
  travelDate: 'travelDate',
  date: 'date',
  hotelName: 'hotelName',
  destination: 'destination',
  destinationHotelName: 'destinationHotelName',
  typeInDestination: 'typeInDestination',
  location: 'location',
  submit: 'submit',
  ticketsButtonLabel: 'ticketsButtonLabel',
  invalidInput: 'invalidInput',
  airport: 'airport',
  travelers: 'travelers',
  type: 'type',
  clear: 'clear',
  edit: 'edit',
  confirm: 'confirm',
  pleaseSelect: 'pleaseSelect',
  hotelStayDates: 'hotelStayDates',
  room: 'room',
  room_other: 'room_other',
  adult: 'adult',
  adult_other: 'adult_other',
  child: 'child',
  child_other: 'child_other',
  select: 'select'
}; export default Keys;